import { create } from "zustand";

export const AsidebarStore = create((set) => ({
  isSideBarOpen: false,
  sideBarOptions: [],
  chatCount: 0,

  setIsSideBarOpen: (mewData) => {
    set((state) => {
      return {
        ...state,
        isSideBarOpen: mewData,
      };
    });
  },

  setSideBarOptions: (newOptions) => {
    set((state) => {
      return {
        ...state,
        sideBarOptions: newOptions,
      };
    });
  },

  setChatCount: (newCount) => {
    set((state) => {
      return {
        ...state,
        chatCount: newCount,
      };
    });
  },
}));
